import React, { Component } from 'react'
import { authContext } from '../../Login/AuthContext';
/*  eslint eqeqeq: 0 */

export default class VentilationTable extends Component {
  constructor (zone, i){
    super();
    this.state = {
      zone: zone.zone,
      place: zone.i,
      token: i.auth.data.token,
      tab: [],
      totals:[],
      full: zone.full
    }
  }
  state = {
    zone : [],
    totals : [],
    place : 0,
    tab: [],
    full: false
  }
  static contextType = authContext;

  componentDidMount = () => {
    this.setState({tab:this.updateVentilationTypes(this.state.zone.shapes, this.state.token, this.state.place)})
  }
  useEffect = (tab) => {
  }

  toCSV = (data) => {
    var dataCSV = this.context.auth.data.dataCSV;
    if(!dataCSV["Ventilation"])
      dataCSV["Ventilation"] = [];
    for(var j=0;j<data.length;j++){
      var d = data[j];
      if(d["categorie"]){
        d.zone = this.state.zone.name;
        dataCSV["Ventilation"].push(d)}
    }
    this.context.setAuthData(this.context.auth.data);
  }

  updateVentilationTypes = (zone, token, i) => {
    fetch("https://mel.dvrc.fr/api/GetBookingDataByAccommodationFromShapeGID36.php?shape_gid="+zone+"&years="+global.years+"&token="+token)
        .then(res => res.json())
        .then( (data) => {
          this.toCSV(data)
          var tab = [];
          tab[0] = {"title":"Categories", "values":[]}
          tab[1] = {"title":"Accommodation", "values":[]}
          for(var i=0;i<global.years.length;i++){
            tab[2+i] = {"title":global.years[i], "values":[]}
          }

          var varTemp, tmp, tmpItem;
          this.setState({totals:data[data.length-1]});
          for(var j=0; j<data.length-1; j++)
          {
            var itemValues=Object.values(data[j]);
            if(varTemp != itemValues[0]){
              if(tmp!=undefined){
                tab[0]["values"].push(tmp);
                if(!this.state.full){
                  tab[1]["values"].push({"name":tmpItem[1], "nb":1});
                  for(var k=0;k<global.years.length;k++){
                    tab[k+2]["values"].push(
                      {"checkin":tmpItem[4*k+4], "nights":tmpItem[4*k+5], "nbaccomm":tmpItem[4*k+6], "nbovernights":tmpItem[4*k+7]}
                    )
                  }
/*                  tab[2]["values"].push({"checkin":tmpItem[4], "nights":tmpItem[7], "nbaccomm":tmpItem[10], "nbovernights":tmpItem[13]});
                  tab[3]["values"].push({"checkin":tmpItem[5], "nights":tmpItem[8], "nbaccomm":tmpItem[11], "nbovernights":tmpItem[14]});
                  tab[4]["values"].push({"checkin":tmpItem[6], "nights":tmpItem[9], "nbaccomm":tmpItem[12], "nbovernights":tmpItem[15]});
*/
                }
              }
              tmpItem = itemValues;
              tmp = {"name":itemValues[0], "nb":1}
              varTemp = itemValues[0];
            } else{
              tmp["nb"]++;
              if(!this.state.full){
                for(var k=1; k<itemValues.length; k++){
                  tmpItem[k] = parseInt(itemValues[k])+parseInt(tmpItem[k]);
                }
              } else {
                tmpItem = itemValues;
              }
            }
            if(this.state.full){
              tab[1]["values"].push({"name":itemValues[1], "nb":1});
              for(var k=0;k<global.years.length;k++){
                tab[k+2]["values"].push(
                  {"checkin":tmpItem[4*k+4], "nights":tmpItem[4*k+5], "nbaccomm":tmpItem[4*k+6], "nbovernights":tmpItem[4*k+7]}
                )
              }
/*              tab[1]["values"].push({"name":itemValues[1], "nb":1});
              tab[2]["values"].push({"checkin":itemValues[4], "nights":itemValues[7], "nbaccomm":itemValues[10], "nbovernights":itemValues[13]});
              tab[3]["values"].push({"checkin":itemValues[5], "nights":itemValues[8], "nbaccomm":itemValues[11], "nbovernights":itemValues[14]});
              tab[4]["values"].push({"checkin":itemValues[6], "nights":itemValues[9], "nbaccomm":itemValues[12], "nbovernights":itemValues[15]});
*/
            }
          }
          if(!this.state.full && tmpItem){
            tab[1]["values"].push({"name":tmpItem[1], "nb":1});
            for(var k=0;k<global.years.length;k++){
              tab[k+2]["values"].push(
                {"checkin":tmpItem[4*k+4], "nights":tmpItem[4*k+5], "nbaccomm":tmpItem[4*k+6], "nbovernights":tmpItem[4*k+7]}
              )
            }
            tmpItem = itemValues;
          }
          tab[0]["values"].push(tmp);

          this.setState({tab:tab});
        })
    }

  lineYear = (year) => {
    var totals = this.state.totals[year];
    var min_year = 3000
    for(var i=0;i<global.years.length;i++)
      min_year = (min_year < global.years[i] ? min_year : global.years[i])
    return (
      <>
        <Line line={this.state.tab[year-min_year+2]} previous={this.state.tab[year-min_year+1]} place={this.state.place} type={1} year={year} totals={totals}/>
        <Line line={this.state.tab[year-min_year+2]} previous={this.state.tab[year-min_year+1]} place={this.state.place} type={2} year={year} totals={totals}/>
        <Line line={this.state.tab[year-min_year+2]} previous={this.state.tab[year-min_year+1]} place={this.state.place} type={3} year={year} totals={totals}/>
        <Line line={this.state.tab[year-min_year+2]} previous={this.state.tab[year-min_year+1]} place={this.state.place} type={4} year={year} totals={totals}/>
      </>
    )
  }

  render () {
    if(!this.state.tab || !this.state.tab[0] || !this.state.tab[0])
      return (<img src="/figs/loading.gif" alt="loading..." />)
    return (
      <table className="table table-bordered" key={"testOther_"+this.state.place}>
        <thead key={"thead_"+this.state.place}>
          <tr key={"head1_bookingTypes_"+this.place}>
            <th colSpan="2" key={"head1_bookingTypes_"+this.place+"_cat"}>Categories</th>
            {
              this.state.tab[0].values.map((elem, i) =>
                  <th colSpan={(this.state.full?elem.nb:1)} key={"head1_bookingTypes_"+this.place+"_cat_"+i}>{elem.name}</th>)
            }
          </tr>
          {
            this.state.full?(
                <tr key={"head2_bookingTypes_"+this.state.place}><th key={"year_"+this.state.place}>Year</th><th key={"type_"+this.state.place}>Type</th>
                {
                  this.state.tab[1].values.map((elem, i) => <th key={"head1_bookingTypes_"+elem.name+"_"+i}>{elem.name}</th>)
                }
                </tr>
            ):""
          }
        </thead>
        <tbody key={"body1_bookingTypes_"+this.state.place}>
        {
          global.years.map((elem, i) =>
            (this.lineYear(elem)))
        }
        </tbody>
      </table>
    )
  }
}

class Line extends Component{
  constructor (input){
    super();
    this.state = {
      line: input.line,
      previous: input.previous,
      year:input.year,
      type:input.type,
      color:global.palette3col[input.year-2018],
      place:input.place,
      totals:input.totals
    }
  }
  static contextType = authContext;

  state = {
    line: [],
    previous: [],
    year:null,
    type:null,
    color:null,
    place:null,
    totals:null
  }

  keys = () => {
    switch(this.state.type){
      case 1: return "nbaccom";
      case 2: return "checkin";
      case 3: return "nights";
      case 4: return "overNights";
      default:return "";
    }
  }

  className = () => {
    switch(this.state.type){
      case 1: return "nbaccomm";
      case 2: return "checkin";
      case 3: return "nights";
      case 4: return "nbovernights";
      default:return "";
    }
  }

  title = () => {
    switch (this.state.type) {
      case 1: return "Hébergements";
      case 2: return "Réservations B";
      case 3: return "Nuits";
      case 4: return "Nuitées estimées";
      default:return "";
    }
  }

  name = (type) => {
    return "line_"+this.state.place+"_"+this.state.type+"_"+this.state.year+"_"+type;
  }

  render () {
    var display = this.context.auth.data.ventilations[this.className()];
    var previous = null;
    if(this.state.previous)
      previous = this.state.previous.values;
    return (
      <>
        <tr className={this.className()} style={{"backgroundColor":this.state.color,"display":(display?"":"none")}} key={this.name("tr1")}>
          <td rowSpan="2" style={{"verticalAlign":"middle"}} key={this.name()+"year"}>{this.state.year}</td>
          <td rowSpan="2" style={{"verticalAlign":"middle"}} key={this.name()+"title"}>{this.title()}</td>
          {
            this.state.line.values.map((elem, i) =>
              <td key={this.name()+"tr1_"+i}>{elem[this.className()]}</td>
            )
          }
        </tr>
        <tr className={this.className()} style={{"backgroundColor":this.state.color,"display":(display?"":"none")}} key={this.name("tr2")}>
          {
            this.state.line.values.map((elem, i) => {
              var val = elem[this.className()];
              var pourc = (Math.ceil(val/this.state.totals[this.keys()]*10000)/100);
              var augm = (previous&&previous[i]&&previous[i][this.className()]>0?(Math.ceil((val-previous[i][this.className()])/previous[i][this.className()]*10000)/100):"");
              if(augm > 0)
                augm = "+"+augm+"%"
              else if (augm < 0)
                augm = augm+"%"
              return (
                <td key={this.name()+"tr2_"+i}>
                  <b>{pourc}%
                  ({augm})</b>
                </td>
              )
            }

            )
          }
        </tr>
      </>
    )
  }
}
